import { useGaugeState } from "@mui/x-charts/Gauge";
import { useTheme } from "@mui/material";
import { VALUE_ANGLE_OFFSET } from "~/pages/space/home-dashboard/SpaceOrWorkspaceRiskCard/components/SpaceRiskGaugeChart/utils/spaceRiskGaugeChartUtils";

const SpaceRiskGaugeChartPointer = () => {
  const { valueAngle, outerRadius, cx, cy } = useGaugeState();
  const theme = useTheme();

  const _cx = cx + VALUE_ANGLE_OFFSET;
  const _cy = cy - VALUE_ANGLE_OFFSET - 5;

  if (valueAngle === null) return null;

  const pointerLength = outerRadius * 1.1;
  const pointerWidth = 8;

  // Tip of the needle
  const tipX = _cx + pointerLength * Math.sin(valueAngle);
  const tipY = _cy - pointerLength * Math.cos(valueAngle);

  // Base corners of the needle (making it a wide triangle)
  const leftBaseX = _cx + pointerWidth * Math.sin(valueAngle - Math.PI / 2);
  const leftBaseY = _cy - pointerWidth * Math.cos(valueAngle - Math.PI / 2);

  const rightBaseX = _cx + pointerWidth * Math.sin(valueAngle + Math.PI / 2);
  const rightBaseY = _cy - pointerWidth * Math.cos(valueAngle + Math.PI / 2);

  return (
    <g>
      {/* Triangle needle */}
      <polygon
        points={`${tipX},${tipY} ${leftBaseX},${leftBaseY} ${rightBaseX},${rightBaseY}`}
        fill={theme.palette.text.primary}
      />
      {/* Center circle */}
      <circle
        cx={_cx}
        cy={_cy}
        r={9}
        fill={theme.palette.background.paper}
        stroke={theme.palette.text.primary}
        strokeWidth={2}
      />
    </g>
  );
};

export default SpaceRiskGaugeChartPointer;
